import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  approvedRequestPO: null,
  loading: false,
  error: null,
};

const approvedRequestPOSlice = createSlice({
  name: "approvedRequestPO",
  initialState,
  reducers: {
    fetchApprovedRequestPOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchApprovedRequestPOSuccess: (state, action) => {
      state.loading = false;
      state.approvedRequestPO = action.payload;
      state.error = null;
    },

    fetchApprovedRequestPOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchApprovedRequestPOStart,
  fetchApprovedRequestPOSuccess,
  fetchApprovedRequestPOFailure,
} = approvedRequestPOSlice.actions;

export default approvedRequestPOSlice.reducer;